import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@okshaun/components";
import "./styles/index.css";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
);
